export default {
  resendId: 'Order id for resubmission',
  resendBtn: 'resend order',
  newVerSoft: 'send information about a new version of the application',
  menu: 'Menu',
  thumbs: 'generate thumbnails',
}
